export default __webpack_public_path__ + "static/home-quick-2b911d5529e6b11066f352e02a6b6c59.svg";